// extracted by mini-css-extract-plugin
module.exports = {"UtilityBoxContainer":"utility-box-v2_UtilityBoxContainer__Ci8gQ","UtilityBoxHome":"utility-box-v2_UtilityBoxHome__KLWhN","UtilityBox":"utility-box-v2_UtilityBox__pXVO1"};